import React, { Fragment, useContext } from 'react'
import AuthState from '../../context/autenticacion/authContext';

const Perfil = () => {

    const authState = useContext(AuthState);
    const { usuario } = authState;

    return (
        <Fragment>
            <h2>Perfil</h2>
            
            <ul className="vista-detalles">
                <div className="info-principal">
                    <li className="info-pequeña">
                        <p><span>Nombre:</span> {usuario.nombre}</p>
                    </li>
                    <li className="info-pequeña">
                        <p><span>Email:</span> {usuario.email}</p>
                    </li>
                </div>
                <div className="info-principal">
                    <li className="info-pequeña">
                        <p><span>Celular:</span> {usuario.celular}</p>
                    </li>
                    <li className="info-pequeña">
                        <p><span>Rol/Cargo: </span> {usuario.rol}</p>
                    </li>
                </div>
            </ul>
        </Fragment>
    );
}

export default Perfil;